import Vue from 'vue'
import Router from 'vue-router'
import i18n from '@/plugins/languages/i18n'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,

  routes: [
    // home
    {
      path: '/',
      name: 'home',

      components: {
        view: () => import('@/views/EditionSection')
      },

      meta: {
        requiresUserAuth: true,
        requiresAcademyAuth: true
      }
    },

    // billing
    {
      path: `/${i18n.t('rPaths.billing')}/:subject`,
      name: 'billing',

      // Children routes
      children: [
        {
          path: ':subedition',
          name: 'billingChild1',
          components: {
            view: () => import('@/views/EditionSection')
          },

          meta: {
            requiresUserAuth: true,
            requiresAcademyAuth: true
          }
        },

        {
          path: ':subid/:subedition',
          name: 'billingChild2',
          components: {
            view: () => import('@/views/EditionSection')
          },

          meta: {
            requiresUserAuth: true,
            requiresAcademyAuth: true
          }
        },

        {
          path: ':subid/:subedition/:thirdid',
          name: 'billingChild3',
          components: {
            view: () => import('@/views/EditionSection')
          },

          meta: {
            isEdition: 'billing',
            requiresUserAuth: true,
            requiresAcademyAuth: true
          }
        }
      ],

      components: {
        view: () => import('@/views/EditionSection')
      },

      meta: {
        requiresUserAuth: true,
        requiresAcademyAuth: true
      }
    },

    {
      path: `/${i18n.t('rPaths.login')}`,
      name: 'userLogin',

      components: {
        view: () => import('@/views/Login')
      },

      meta: {
        requiresUserAuth: false,
        requiresAcademyAuth: false
      }
    },

    // login-callback
    {
      path: '/login-callback',
      name: 'login',

      components: {
        view: () => import('@/views/LoginCallback')
      },

      meta: {
        requiresUserAuth: false,
        requiresAcademyAuth: false
      }
    },

    // no-encotrada
    {
      path: `/${i18n.t('rPaths.notFound')}`,
      name: 'notFound',

      components: {
        view: () => import('@/views/NotFound')
      },

      meta: {
        requiresUserAuth: true,
        requiresAcademyAuth: true
      }
    },

    {
      path: '*',
      redirect: { name: 'notFound' }
    }
  ],

  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  if (!to.meta.requiresUserAuth ||
      (router.app.$auth.isUserAuthenticated() && !to.meta.requiresAcademyAuth) ||
      (router.app.$auth.isUserAuthenticated() && router.app.$auth.isAcademyAuthenticated())) {
    next()
  } else {
    router.app.$auth.login()
  }
})

export default router
